import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import API from "../../actions";
import queryString from "query-string";

export default props => {
    const clientId = queryString.parse(props.location.search).clientId;
    return (
        <div>
            <Typography component="h1" variant="h5">
                Du er ved at afmelde dig nyhedsbreve
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                    await API.clientUnsubscribe(clientId);
                    alert("Du er nu afmeldt nyhedsbreve");
                }}>
                Bekræft
            </Button>
        </div>
    );
};
